import request from '../utils/request'


//字典
export function getdictdata(query) {
	return request({
		url: '/api/dict/data/'+query.id,
		method: 'get',
		params: query
	})
}
export function gethomeStatistics(query) {
	return request({
		url: '/api/statistics/homeStatistics',
		method: 'get',
		params: query
	})
}
//查询企业列表
export function getenterpriselist(query) {
	return request({
		url: '/api/enterprise/list',
		method: 'get',
		params: query
	})
}
export function getenterprisedetail(query) {
	return request({
		url: '/api/enterprise/'+query.id,
		method: 'get',
		params: query
	})
}

export function getoccupationalClassification(query) {
	return request({
		url: '/api/occupationalClassification/list',
		method: 'get',
		params: query
	})
}